import { SvelteSubject } from "@common/store/reactive"

export const openMainMenu = new SvelteSubject(false)

export const appInitialized = new SvelteSubject(false)